var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.37258 5.87258 0 12.5 0H30.5C37.1274 0 42.5 5.37258 42.5 12V30C42.5 36.6274 37.1274 42 30.5 42H12.5C5.87258 42 0.5 36.6274 0.5 30V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H14.5H30.5",
    fill: "#FF3B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H14.5H30.5",
    stroke: "#FF3B2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15V13C17.5 12.4696 17.7107 11.9609 18.0858 11.5858C18.4609 11.2107 18.9696 11 19.5 11H23.5C24.0304 11 24.5391 11.2107 24.9142 11.5858C25.2893 11.9609 25.5 12.4696 25.5 13V15M28.5 15V29C28.5 29.5304 28.2893 30.0391 27.9142 30.4142C27.5391 30.7893 27.0304 31 26.5 31H16.5C15.9696 31 15.4609 30.7893 15.0858 30.4142C14.7107 30.0391 14.5 29.5304 14.5 29V15H28.5Z",
    stroke: "#FF3B2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20V26",
    stroke: "#FF3B2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20V26",
    stroke: "#FF3B2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5H30.5V-1.5H12.5V1.5ZM41 12V30H44V12H41ZM30.5 40.5H12.5V43.5H30.5V40.5ZM2 30V12H-1V30H2ZM12.5 40.5C6.70101 40.5 2 35.799 2 30H-1C-1 37.4558 5.04416 43.5 12.5 43.5V40.5ZM41 30C41 35.799 36.299 40.5 30.5 40.5V43.5C37.9558 43.5 44 37.4558 44 30H41ZM30.5 1.5C36.299 1.5 41 6.20101 41 12H44C44 4.54416 37.9558 -1.5 30.5 -1.5V1.5ZM12.5 -1.5C5.04416 -1.5 -1 4.54416 -1 12H2C2 6.20101 6.70101 1.5 12.5 1.5V-1.5Z",
    fill: "#FF3B2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.80627bb1.svg";
export { ForwardRef as ReactComponent };